const RESOURCE_NAME = '/geotab';
export default axios => ({
    getCredentials(unitId) {
        return axios.get(`/units/${unitId}/ext-services${RESOURCE_NAME}/credentials`, {});
    }
});
